module.exports = __webpack_public_path__ + "static/media/sales.93c5ba85.svg";